let modalUpdateCallback = undefined;
let updateStateId = 0;

let modalState = {
  alerts: [],
};

function reRenderModal() {
  setTimeout(() => {
    modalUpdateCallback(++updateStateId);
  }, 50);
}

export function bindAlertModalUpdate(modalUpdate) {
  modalUpdateCallback = modalUpdate;
}

export function Alert(props) {
  if (!modalUpdateCallback) {
    // Silence alerts when widget is closed
    return;
  }

  const { duration = 4000, type, ...rest } = props;
  const useStateId = ++updateStateId;

  modalState.alerts[useStateId] = { ...rest, type, ...{ open: true } };
  reRenderModal();

  const isError = type === 'error';
  if (!isError && duration !== null && duration !== undefined) {
    setTimeout(() => {
      modalState.alerts[useStateId] = { ...rest, type, ...{ open: false } };
      reRenderModal();
      return clearModal(useStateId);
    }, duration);
  }
}

export function getState() {
  return modalState;
}

export function clearModal(id) {
  if (!modalUpdateCallback) {
    // Silence alerts when widget is closed
    return;
  }

  if (!id) {
    modalState.alerts = [];
    reRenderModal();
    return;
  }

  if (id in modalState.alerts) {
    delete modalState.alerts[id];
    reRenderModal();
  }
}
